import React from 'react';

export default function Hero() {
  return (
    <section className="bg-white py-20 md:py-32">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center gap-12">
          {/* Headshot */}
          <div className="flex-shrink-0">
            <img 
              src="/images/julianne-headshot.jpg" 
              alt="Julianne Lee" 
              className="w-64 h-128 rounded-2xl object-cover shadow-lg"
            />
          </div>
          
          {/* Content */}
          <div className="flex-1">
            <h1 className="text-6xl md:text-7xl font-bold mb-6 text-gray-900">Julianne Lee</h1>
            <p className="text-2xl md:text-3xl text-gray-700 mb-8">Software Engineer</p>
            <div className="flex gap-4 flex-wrap">
              <a 
                href="#projects" 
                className="bg-blue-600 text-white px-8 py-3 rounded-lg hover:bg-blue-700 transition font-semibold"
              >
                View Experience
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
